module.exports = __webpack_public_path__ + "media/images/icons/twitter-474ccb90699106d2cfbbdf1e3c47e789.svg";